import React, { useContext } from 'react'
import './index.scss'
import { observer } from 'mobx-react'
import NakedButton from '@Components/Buttons/NakedButton'
import ResultsCardTable from '@Components/Tables/ResultsCardTable'
import { PaginationBody } from '@Entities/pagination'
import { WorkModel } from '@Entities/work/work'
import RootStore from '@App/stores/root-store'
import { StoresContext } from '@App/contexts'
import WorkItemData from '@Components/WorkItemV2/work-item-data'
import { v4 as uuidv4 } from 'uuid'
import { DualSearchStore } from '@App/stores/search/party/dual-search-store'

interface PartyWorksTableProps<resultType> {
    searchPartyStore: DualSearchStore<resultType>
    extendedCardType: React.ComponentType<WorkItemData>
    className?: string
    /** For a query-driven store: the works are fetched by a query, so it supplies the loading state and the paging. */
    loading?: boolean
    onChangePage?: (pagination: PaginationBody) => void
    onChangeLimit?: (newLimit: number) => void
}

const PartyWorksTable = <resultType,>({
    searchPartyStore,
    extendedCardType,
    className,
    loading = false,
    onChangePage: onChangePageOverride,
    onChangeLimit: onChangeLimitOverride,
}: PartyWorksTableProps<resultType>) => {
    const { publicViewWorkStore } = useContext<RootStore>(StoresContext)

    const onChangePage =
        onChangePageOverride ??
        (async (pagination: PaginationBody) => {
            await searchPartyStore.onChangeSecondarySearchPage(pagination)
        })

    const onChangeLimit =
        onChangeLimitOverride ??
        (async (newLimit: number) => {
            await searchPartyStore.secondarySetPageLimit(newLimit)
        })

    const count = searchPartyStore.secondarySearchResults?.count || 0
    const paginationInfo = searchPartyStore.secondarySearchPaginationInfo
    const limit = searchPartyStore.secondaryResultsPerPageLimit
    const worksResultMessage = searchPartyStore.worksResultMessage

    const handleClickCard = (selectedWork: WorkModel) => {
        publicViewWorkStore.setViewWorkPublic(selectedWork)
    }

    const workItemDataList: WorkItemData[] =
        searchPartyStore.secondarySearchResults?.works.map((work) => ({
            work,
            handleOnClick: handleClickCard,
            getId: () => work.id || uuidv4(),
            displayType: searchPartyStore.displayType,
        })) || []

    return (
        <div className="party-works-table">
            <NakedButton onClick={() => searchPartyStore.setShowWorks(false)}>&lt; Back</NakedButton>
            <ResultsCardTable
                items={workItemDataList}
                paginationInfo={paginationInfo}
                count={count}
                limit={limit}
                loading={loading}
                extendedCardType={extendedCardType}
                onChangePage={onChangePage}
                onChangeLimit={onChangeLimit}
                paginationResultsMessage={worksResultMessage}
                outerDivClassName={className}
            />
        </div>
    )
}

export default observer(PartyWorksTable)
